import axios from 'axios'

export const http = axios.create({
    baseURL:'https://trabalheescriba.herokuapp.com/'
})